<template>
  <div>
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Segmentation tester</h3>
        <p class="mt-5">
          Labels are tags that can be added to a user either manually or with an automation or form. It must
          be added here first.
        </p>
      </vs-col>
    </vs-row>

    <guest-query-builder :guestQuery.sync="guestQuery" />

    <vs-row class="mt-4" vs-align="center">
      <vs-button @click="submitQuery">Run query</vs-button>
      <div v-if="queryResult != -1 && !isQuerying" class="ml-4 flex items-center">
        <b>Estimated number of guests:</b> <span class="ml-2">{{ queryResult }}</span>
        <feather-icon class="ml-1" icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
      </div>
    </vs-row>

    <div style="height: 400px"></div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

import GuestQueryBuilder from "@/components/GuestQueryBuilder.vue";

export default {
  components: {
    GuestQueryBuilder,
  },
  data() {
    return {
      moment,

      queryResult: -1,

      guestQuery: {
        hasAge: false,
        hasLabels: false,
        hasInterest: false,
        hasConsents: false,

        ageRange: [18, 40],
        labels: [],
        interestKey: null,
        interestValue: "",
        consentVenues: [],
        consentTypes: [],
      },
    };
  },
  methods: {
    async submitQuery() {
      console.log("Submitted query", this.guestQuery);
      const result = await this.$store.dispatch("guestProfiles/getCountByGuestQuery", this.guestQuery);
      this.queryResult = result;
    },
  },
  computed: {
    ...mapGetters({
      isQuerying: "guestProfiles/guestQuerySearching",
    }),
  },
};
</script>

<style lang="scss" scoped>
.color-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: rgba(var(--vs-primary)) !important;
  box-shadow: 0px 15px 40px -10px rgba(var(--vs-primary), 0.9);

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;

  opacity: 1;
  transition: opacity 0.15s;

  &.hide {
    opacity: 0;
    pointer-events: none;
  }
}
</style>